import { useTranslation } from 'react-i18next';
import { Badge } from '../components/Badge';
import { Button } from '../components/Button';
import './Hero.css';

export function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="container hero__inner">
        <Badge>{t('hero.badge')}</Badge>
        <h1 className="hero__title">{t('hero.title')}</h1>
        <p className="hero__subtitle">{t('hero.subtitle')}</p>
        <div className="hero__ctas">
          <Button as="a" href="#waitlist" size="lg">{t('hero.ctaPrimary')}</Button>
          <Button as="a" href="#how" size="lg" variant="ghost">{t('hero.ctaSecondary')}</Button>
        </div>
        <p className="hero__trustline">{t('hero.trustline')}</p>

        <div className="hero__mockup" aria-hidden="true">
          <div className="hero__mockup-chrome">
            <span className="hero__mockup-dot hero__mockup-dot--red" />
            <span className="hero__mockup-dot hero__mockup-dot--yellow" />
            <span className="hero__mockup-dot hero__mockup-dot--green" />
            <span className="hero__mockup-title">Teams · General · MeetFlow</span>
          </div>
          <div className="hero__mockup-body">
            <div className="hero__mockup-tabs">
              <span className="hero__mockup-tab hero__mockup-tab--active">Agenda</span>
              <span className="hero__mockup-tab">Notes</span>
              <span className="hero__mockup-tab">Agreements</span>
              <span className="hero__mockup-tab">History</span>
            </div>
            <div className="hero__mockup-rows">
              <div className="hero__mockup-row">
                <span className="hero__mockup-check hero__mockup-check--done" />
                <span className="hero__mockup-text hero__mockup-text--strike">Q2 roadmap review</span>
              </div>
              <div className="hero__mockup-row">
                <span className="hero__mockup-check" />
                <span className="hero__mockup-text">Blockers from engineering</span>
                <span className="hero__mockup-owner">Ana</span>
              </div>
              <div className="hero__mockup-row">
                <span className="hero__mockup-check" />
                <span className="hero__mockup-text">Decide on launch date</span>
                <span className="hero__mockup-owner">Oscar</span>
              </div>
              <div className="hero__mockup-row hero__mockup-row--agreement">
                <span className="hero__mockup-pill">Agreement</span>
                <span className="hero__mockup-text">Ship MVP by May 30</span>
                <span className="hero__mockup-owner hero__mockup-owner--coral">Planner →</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
